import { c as _c } from "react/compiler-runtime";
import { Chip } from '@module/mdrt-org/shared/components/chip/chip';
import { ImageWrapper } from '@module/mdrt-org/shared/components/image-wrapper/image-wrapper';
import { useGlobalCmsContentContext } from '@module/mdrt-org/shared/components/providers/global-cms-context';
import { type MembershipToolkitTabs } from '@module/mdrt-org/shared/utils/types/membership-toolkit-tabs';
import { Card } from '@shared/ui-components/card/card';
import { ChipTheme } from '@shared/ui-components/chip/chipTheme';
import { ArticleIcon } from '@shared/ui-components/svgs';
import { isDashboardCarouselCardToolkitLinkItem, type LinksListItem } from '../../get-membership-toolkit-content';
import styles from './toolkit-item-card.module.scss';
export const ToolkitItemCard = t0 => {
  const $ = _c(24);
  const {
    link,
    LinksListSectionTitle,
    MembershipToolkitTabsSectionTitle,
    sendMemberToolkitIntoGTM
  } = t0;
  const {
    cmsContent
  } = useGlobalCmsContentContext();
  let t1;
  if ($[0] !== cmsContent || $[1] !== link) {
    t1 = isDashboardCarouselCardToolkitLinkItem(link) ? {
      imageAlt: link.Title,
      imageUrl: link.ImageReference?.Url,
      linkLabel: link.CardUrl.DisplayText,
      linkUrl: link.CardUrl.LinkToContent,
      target: link.CardUrl.Target,
      title: link?.Title
    } : {
      imageAlt: link.DisplayText,
      imageUrl: link.LinkToContent,
      linkLabel: link.DisplayText ?? cmsContent.downloadLabel,
      linkUrl: link.ShouldDownload && link.DownloadFileName ? `${link.LinkToContent}?download=${link.DownloadFileName}` : link.LinkToContent,
      target: link.Target ?? "_blank"
    };
    $[0] = cmsContent;
    $[1] = link;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cardProps = t1;
  let t2;
  if ($[3] !== cardProps.imageAlt || $[4] !== cardProps.imageUrl) {
    t2 = mimeType => {
      switch (mimeType) {
        case "application/gzip":
        case "application/vnd.rar":
        case "application/x-7z-compressed":
        case "application/x-gzip":
        case "application/x-zip-compressed":
        case "application/zip":
          {
            return <ArticleIcon className={styles["toolkit-item-card__icon"]} />;
          }
        case "application/msword":
        case "application/rtf":
        case "application/vnd.oasis.opendocument.text":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          {
            return <ArticleIcon className={styles["toolkit-item-card__icon"]} />;
          }
        case "application/pdf":
          {
            return <ArticleIcon className={styles["toolkit-item-card__icon"]} />;
          }
        case "application/vnd.ms-excel":
        case "application/vnd.oasis.opendocument.spreadsheet":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "text/csv":
          {
            return <ArticleIcon className={styles["toolkit-item-card__icon"]} />;
          }
        case "application/vnd.ms-powerpoint":
        case "application/vnd.oasis.opendocument.presentation":
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
          {
            return <ArticleIcon className={styles["toolkit-item-card__icon"]} />;
          }
        case "image/bmp":
        case "image/gif":
        case "image/jpeg":
        case "image/png":
        case "image/svg+xml":
        case "image/tiff":
        case "image/webp":
          {
            return <ImageWrapper alt={cardProps.imageAlt} className={styles["toolkit-item-card__image"]} height={450} quality={100} sizes="(min-width: 1300px) 300px, (min-width: 940px) 30vw, (min-width: 380px) 50vw, 34vw" src={cardProps.imageUrl} width={450} />;
          }
        default:
          {
            return <ArticleIcon className={styles["toolkit-item-card__icon"]} />;
          }
      }
    };
    $[3] = cardProps.imageAlt;
    $[4] = cardProps.imageUrl;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const renderContent = t2;
  let t3;
  if ($[6] !== renderContent) {
    t3 = renderContent("image/jpeg");
    $[6] = renderContent;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== cardProps.title) {
    t4 = cardProps.title && <div className={styles["toolkit-item-card__title"]}>{cardProps.title}</div>;
    $[8] = cardProps.title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== LinksListSectionTitle || $[11] !== MembershipToolkitTabsSectionTitle || $[12] !== cardProps.linkUrl || $[13] !== sendMemberToolkitIntoGTM) {
    t5 = () => sendMemberToolkitIntoGTM({
      LinksListSectionTitle,
      linkURL: cardProps.linkUrl,
      MembershipToolkitTabsSectionTitle
    });
    $[10] = LinksListSectionTitle;
    $[11] = MembershipToolkitTabsSectionTitle;
    $[12] = cardProps.linkUrl;
    $[13] = sendMemberToolkitIntoGTM;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== cardProps.linkLabel || $[16] !== cardProps.linkUrl || $[17] !== cardProps.target || $[18] !== t5) {
    t6 = <div className={styles["toolkit-item-card__actions-container"]}><Chip className={styles["toolkit-item-card__action"]} label={cardProps.linkLabel} onClick={t5} scroll={false} target={cardProps.target} theme={ChipTheme.Light} to={cardProps.linkUrl} /></div>;
    $[15] = cardProps.linkLabel;
    $[16] = cardProps.linkUrl;
    $[17] = cardProps.target;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t3 || $[21] !== t4 || $[22] !== t6) {
    t7 = <Card className={styles["toolkit-item-card"]}>{t3}{t4}{t6}</Card>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};